/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreTimesheetResponseDto } from '../models/core-timesheet-response-dto';
import { timesheetsControllerCreate } from '../fn/timesheets/timesheets-controller-create';
import { TimesheetsControllerCreate$Params } from '../fn/timesheets/timesheets-controller-create';
import { timesheetsControllerDelete } from '../fn/timesheets/timesheets-controller-delete';
import { TimesheetsControllerDelete$Params } from '../fn/timesheets/timesheets-controller-delete';
import { timesheetsControllerFindAll } from '../fn/timesheets/timesheets-controller-find-all';
import { TimesheetsControllerFindAll$Params } from '../fn/timesheets/timesheets-controller-find-all';
import { timesheetsControllerFindById } from '../fn/timesheets/timesheets-controller-find-by-id';
import { TimesheetsControllerFindById$Params } from '../fn/timesheets/timesheets-controller-find-by-id';
import { timesheetsControllerFindByProjectAndPeriod } from '../fn/timesheets/timesheets-controller-find-by-project-and-period';
import { TimesheetsControllerFindByProjectAndPeriod$Params } from '../fn/timesheets/timesheets-controller-find-by-project-and-period';
import { timesheetsControllerFindByUserId } from '../fn/timesheets/timesheets-controller-find-by-user-id';
import { TimesheetsControllerFindByUserId$Params } from '../fn/timesheets/timesheets-controller-find-by-user-id';
import { timesheetsControllerUpdate } from '../fn/timesheets/timesheets-controller-update';
import { TimesheetsControllerUpdate$Params } from '../fn/timesheets/timesheets-controller-update';

@Injectable({ providedIn: 'root' })
export class CoreTimesheetsService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timesheetsControllerFindAll()` */
  static readonly TimesheetsControllerFindAllPath = '/o2-core/timesheets/{tenant}';

  /**
   * Get all timesheets for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetsControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindAll$Response(params: TimesheetsControllerFindAll$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>> {
    const obs = timesheetsControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all timesheets for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetsControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindAll(params: TimesheetsControllerFindAll$Params, context?: HttpContext): Observable<Array<CoreTimesheetResponseDto>> {
    const resp = this.timesheetsControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>): Array<CoreTimesheetResponseDto> => r.body)
    );
  }

  /** Path part for operation `timesheetsControllerCreate()` */
  static readonly TimesheetsControllerCreatePath = '/o2-core/timesheets/{tenant}';

  /**
   * Create a new timesheet entry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetsControllerCreate$Response(params: TimesheetsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetResponseDto>> {
    const obs = timesheetsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new timesheet entry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetsControllerCreate(params: TimesheetsControllerCreate$Params, context?: HttpContext): Observable<CoreTimesheetResponseDto> {
    const resp = this.timesheetsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreTimesheetResponseDto>): CoreTimesheetResponseDto => r.body)
    );
  }

  /** Path part for operation `timesheetsControllerFindByUserId()` */
  static readonly TimesheetsControllerFindByUserIdPath = '/o2-core/timesheets/{tenant}/user/{userId}';

  /**
   * Get timesheets for a specific user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetsControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindByUserId$Response(params: TimesheetsControllerFindByUserId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>> {
    const obs = timesheetsControllerFindByUserId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get timesheets for a specific user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetsControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindByUserId(params: TimesheetsControllerFindByUserId$Params, context?: HttpContext): Observable<Array<CoreTimesheetResponseDto>> {
    const resp = this.timesheetsControllerFindByUserId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>): Array<CoreTimesheetResponseDto> => r.body)
    );
  }

  /** Path part for operation `timesheetsControllerFindByProjectAndPeriod()` */
  static readonly TimesheetsControllerFindByProjectAndPeriodPath = '/o2-core/timesheets/{tenant}/project/{projectId}/period';

  /**
   * Get timesheets of a project within a date range.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetsControllerFindByProjectAndPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindByProjectAndPeriod$Response(params: TimesheetsControllerFindByProjectAndPeriod$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>> {
    const obs = timesheetsControllerFindByProjectAndPeriod(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get timesheets of a project within a date range.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetsControllerFindByProjectAndPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindByProjectAndPeriod(params: TimesheetsControllerFindByProjectAndPeriod$Params, context?: HttpContext): Observable<Array<CoreTimesheetResponseDto>> {
    const resp = this.timesheetsControllerFindByProjectAndPeriod$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>): Array<CoreTimesheetResponseDto> => r.body)
    );
  }

  /** Path part for operation `timesheetsControllerFindById()` */
  static readonly TimesheetsControllerFindByIdPath = '/o2-core/timesheets/{tenant}/id/{id}';

  /**
   * Get a timesheet by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetsControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindById$Response(params: TimesheetsControllerFindById$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetResponseDto>> {
    const obs = timesheetsControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a timesheet by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetsControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerFindById(params: TimesheetsControllerFindById$Params, context?: HttpContext): Observable<CoreTimesheetResponseDto> {
    const resp = this.timesheetsControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreTimesheetResponseDto>): CoreTimesheetResponseDto => r.body)
    );
  }

  /** Path part for operation `timesheetsControllerDelete()` */
  static readonly TimesheetsControllerDeletePath = '/o2-core/timesheets/{tenant}/id/{id}';

  /**
   * Delete a timesheet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerDelete$Response(params: TimesheetsControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetResponseDto>> {
    const obs = timesheetsControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a timesheet.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetsControllerDelete(params: TimesheetsControllerDelete$Params, context?: HttpContext): Observable<CoreTimesheetResponseDto> {
    const resp = this.timesheetsControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreTimesheetResponseDto>): CoreTimesheetResponseDto => r.body)
    );
  }

  /** Path part for operation `timesheetsControllerUpdate()` */
  static readonly TimesheetsControllerUpdatePath = '/o2-core/timesheets/{tenant}/id/{id}';

  /**
   * Update a timesheet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetsControllerUpdate$Response(params: TimesheetsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetResponseDto>> {
    const obs = timesheetsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a timesheet.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetsControllerUpdate(params: TimesheetsControllerUpdate$Params, context?: HttpContext): Observable<CoreTimesheetResponseDto> {
    const resp = this.timesheetsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreTimesheetResponseDto>): CoreTimesheetResponseDto => r.body)
    );
  }

}
